import React from "../../../lib/teact/teact";

interface TelegramLinkProps {
  username: string;       // Tên username của bot, ví dụ "bachkhoaAIbot"
  label?: string;         // Nhãn nút, mặc định "Chat với bot"
  useProtocol?: boolean;  // Nếu true thì dùng tg:// trước, fallback sang https://
}

const TelegramBotLink: React.FC<TelegramLinkProps> = ({
  username,
  label = "Chat với trợ lý ảo",
  useProtocol = true,
}) => {
  const httpsUrl = `https://t.me/${username}`;
  const tgProtocolUrl = `tg://resolve?domain=${username}`;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (useProtocol) {
      // Thử mở app Telegram
      window.location.href = tgProtocolUrl;

      // Fallback sang https nếu không có Telegram app
      setTimeout(() => {
        window.open(httpsUrl, "_blank");
      }, 500);
      e.preventDefault();
    }
  };

  return (
    <a
      href={httpsUrl}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 16px",
        backgroundColor: "#0088cc",
        color: "#fff",
        borderRadius: "8px",
        textDecoration: "none",
        fontWeight: "bold",
        transition: "background-color 0.2s ease-in-out",
      }}
      onMouseEnter={(e) =>
        ((e.target as HTMLAnchorElement).style.backgroundColor = "#d3dbdfff")
      }
      onMouseLeave={(e) =>
        ((e.target as HTMLAnchorElement).style.backgroundColor = "#f0f5f7ff")
      }
    >
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 240 240"
        fill="white"
      >
        <path d="M120 0C53.726 0 0 53.726 0 120s53.726 120 120 120 120-53.726 120-120S186.274 0 120 0zm58.408 82.41l-24.93 117.777c-1.862 8.3-6.74 10.358-13.64 6.462l-37.73-27.807-18.2 17.518c-2.016 2.015-3.7 3.7-7.584 3.7l2.713-38.473 69.932-63.16c3.042-2.713-0.662-4.225-4.708-1.513l-86.46 54.468-37.32-11.684c-8.104-2.528-8.3-8.103 1.69-12.03l145.64-56.17c6.74-2.528 12.64 1.513 10.46 12.03z" />
      </svg> */}
      {label}
    </a>
  );
};

export default TelegramBotLink;